export enum USER_QUIZ_PROBLEM {
  LOWER_BACK = 'LOWER_BACK',
  NECK = 'NECK',
  KNEE = 'KNEE',
  SHOULDER = 'SHOULDER',
  FOOT = 'FOOT',
  ELBOW = 'ELBOW',
}
